import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr";
import en from "./locales/en";
import es from "./locales/es";

const supportedLngs = ["fr", "en", "es"] as const;
export type Locale = (typeof supportedLngs)[number];

function normalizeLocale(raw?: string): Locale {
  const lng = raw?.toLowerCase().split(/[-_]/)[0] || "fr";
  return supportedLngs.includes(lng as Locale) ? (lng as Locale) : "fr";
}

function applyDocumentLanguage(raw?: string) {
  if (typeof document === "undefined") return;
  const locale = normalizeLocale(raw);
  document.documentElement.lang = locale;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "fr",
    supportedLngs: [...supportedLngs],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    react: {
      useSuspense: true,
    },
  });

i18n.on("initialized", () => {
  applyDocumentLanguage(i18n.language);
});

i18n.on("languageChanged", (lng: string) => {
  applyDocumentLanguage(lng);
});

/** Langue courante normalisée (fr, en ou es). */
export function getCurrentLocale(): Locale {
  return normalizeLocale(i18n.language);
}

export default i18n;
